import { Serializable } from '@/models/core/serializable';

export class RecommendationLetter implements Serializable<RecommendationLetter> {
  id: number = 0;
  title: string = '';
  studentID: number = 0;
  content: string = '';
  preference: string = '';
  targetInstitution: string = '';
  generationPolicy: string[] = [];
  lastUpdateUserName: string = '';
  generationRequest: RecommendationLetterGenerationRequest = new RecommendationLetterGenerationRequest();
  createdAt: string = '';
  updatedAt: string = '';

  deserialize(input: any): RecommendationLetter {
    if (input) {
      this.id = input.id;
      this.title = input.title;
      this.studentID = input.studentID;
      this.content = input.content;
      this.targetInstitution = input.targetInstitution;
      this.generationPolicy = input.generationPolicy;
      this.lastUpdateUserName = input.lastUpdateUserName;
      this.generationRequest = new RecommendationLetterGenerationRequest().deserialize(input.generationRequest);
      this.createdAt = input.createdAt;
      this.updatedAt = input.updatedAt;
    }
    return this;
  }
}

export class RecommendationLetterPolicies implements Serializable<RecommendationLetterPolicies> {
  policies: string[] = [];

  deserialize(input: any): RecommendationLetterPolicies {
    if (input) {
      this.policies = input.policies;
    }
    return this;
  }
}

export class GeneratedRecommendationLetter implements Serializable<GeneratedRecommendationLetter> {
  recommendationLetterId: number = 0;
  recommendationLetter: string = '';

  deserialize(input: any): GeneratedRecommendationLetter {
    if (input) {
      this.recommendationLetterId = input.recommendationLetterID;
      this.recommendationLetter = input.recommendationLetter;
    }
    return this;
  }
}

export class GeneratedRecommendationLetterItem implements Serializable<GeneratedRecommendationLetterItem> {
  id: number = 0;
  generationPolicy: string = '';
  title: string = '';
  content: string = '';
  updatedAt: string = '';

  deserialize(input: any): GeneratedRecommendationLetterItem {
    if (input) {
      this.id = input.id;
      this.generationPolicy = input.generationPolicy;
      this.title = input.title;
      this.content = input.content;
      this.updatedAt = input.updatedAt;
    }
    return this;
  }
}

export class GeneratedRecommendationLettersResponse implements Serializable<GeneratedRecommendationLettersResponse> {
  recommendationLetters: GeneratedRecommendationLetterItem[] = [];

  deserialize(input: any): GeneratedRecommendationLettersResponse {
    if (input && input.recommendationLetters) {
      this.recommendationLetters = input.recommendationLetters.map((item: any) => new GeneratedRecommendationLetterItem().deserialize(item));
    }
    return this;
  }
}

export class RecommendationLetterGenerationRequest implements Serializable<RecommendationLetterGenerationRequest> {
  temperature: number = 0; 
  achievements: string = ''; 
  desiredLength: number = 1000;
  universityInfo: string = '';
  admissionPolicy: string = '';
  motivationLetter: string = '';
  personalityEpisode: string = '';
  generationPreferences: string[] = []; 
  recommendationGuidelines: string = '';
  mostSignificantAchievement: string = '';

  deserialize(input: any): RecommendationLetterGenerationRequest {
    if (input) {
      // API からのレスポンスで、generationRequest は string なので parse() しています
      const obj = JSON.parse(input);
      this.temperature = obj.temperature;
      this.achievements = obj.achievements;
      this.desiredLength = obj.desiredLength;
      this.universityInfo = obj.universityInfo;
      this.admissionPolicy = obj.admissionPolicy;
      this.motivationLetter = obj.motivationLetter;
      this.personalityEpisode = obj.personalityEpisode;
      this.generationPreferences = obj.generationPreferences;
      this.recommendationGuidelines = obj.recommendationGuidelines;
      this.mostSignificantAchievement = obj.mostSignificantAchievement;
    }
    return this;
  }
}